import { DateTime } from 'luxon';
import { ParsedFullMessage } from 'src/app/private/shared/dtos/glai.dto';

// supplies more readable date with recent days as strings
export function getChatHistoryDisplayDate(timestamp: number): string {
  const seconds =
    timestamp > 9999999999 ? Math.floor(timestamp / 1000) : timestamp;
  const rowDate = DateTime.fromSeconds(seconds).startOf('day');
  const today = DateTime.local().startOf('day');
  const yesterday = today.minus({ days: 1 });

  if (rowDate.equals(today)) {
    return 'Today';
  }

  if (rowDate.equals(yesterday)) {
    return 'Yesterday';
  }
  return rowDate.toFormat('MM/dd/yy');
}

export function parseFullMessage(
  fullMessage?: string
): ParsedFullMessage | null {
  if (!fullMessage) {
    return null;
  }

  try {
    return JSON.parse(fullMessage) as ParsedFullMessage;
  } catch {
    return null;
  }
}
